"use strict";

exports.__esModule = true;
exports.StandardReportDataProvider = StandardReportDataProvider;
var _react = _interopRequireDefault(require("react"));
var _URLFilter = require("../../Core/URLFilter");
var _ReportURLFilter = require("../ReportURLFilter");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _Calendar = require("../../Calendar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function StandardReportDataProvider(props) {
  var children = props.children,
    timeRangeKind = props.timeRangeKind;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  return /*#__PURE__*/_react["default"].createElement(_Calendar.CalendarController, null, function (calendarProps) {
    return /*#__PURE__*/_react["default"].createElement(_Calendar.CalendarContext.Provider, {
      value: calendarProps
    }, /*#__PURE__*/_react["default"].createElement(_ReportURLFilter.ReportURLFilter, {
      timeRangeKind: timeRangeKind
    }, function (urlFilter) {
      var _urlFilter$filters = urlFilter.filters,
        deviceUuids = _urlFilter$filters.device,
        tags = _urlFilter$filters.tags,
        deviceTypes = _urlFilter$filters.deviceTypes;
      var filteredDevices = devices;
      if (deviceUuids.length > 0) {
        filteredDevices = devices.filter(function (device) {
          return deviceUuids.includes(device.uuid);
        });
      }
      if (tags.length > 0) {
        filteredDevices = filteredDevices.filter(function (device) {
          return device.tags.some(function (tag) {
            return tags.includes(tag);
          });
        });
      }
      if (deviceTypes.length > 0) {
        filteredDevices = filteredDevices.filter(function (device) {
          return Array.isArray(deviceTypes) && deviceTypes.length ? deviceTypes.includes(device.deviceType) : true;
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_URLFilter.URLFilterContext.Provider, {
        value: urlFilter
      }, /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Provider, {
        value: filteredDevices
      }, /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodController, null, function (reportingPeriod) {
        return /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodContext.Provider, {
          value: reportingPeriod
        }, children);
      })));
    }));
  });
}